export const SIZING_RANGES_GET_REQUEST = "@sizingRanges.get.request";
export const SIZING_RANGES_GET_SUCCESS = "@sizingRanges.get.success";
export const SIZING_RANGES_GET_FAIL = "@sizingRanges.get.failure";
